export default "__VITE_ASSET__f26dbcf9__"